import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import moment from "moment";
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Swal from 'sweetalert2'
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import HomeIcon from '@material-ui/icons/Home';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';

import MaterialCreate from '../Materials/MaterialCreate';
import MaterialEdit from '../Materials/MaterialEdit';
import MaterialDelete from '../Materials/MaterialDelete';


function MaterialList() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료
  const gridRef = useRef();
  const [materialList, setMaterialList] = useState([]);
  const [purSelectData, setPurSelectData] = useState([]);
  const [supplier, setSupplier] = useState(null); //업체명/코드
  const [materialCode, setMaterialCode] = useState(''); //자재규격
  const [materialGubun, setMaterialGubun] = useState(''); //자재구분
  const [materialYesNo, setMaterialYesNo] = useState('Yes'); //업체자재사용유무
  const [materialNameChange, setMaterialNameChange] = useState('');

  const [materialEditValue, setMaterialEditValue] = useState(''); // edit Id저장하기
  const [materialDeleteValue, setMaterialDeleteValue] = useState(''); // delete 자료props 삭제하기

  const [materialCreateModal, setMaterialCreateModal] = useState(false); //자료등록모달
  const [materialEditModal, setMaterialEditModal] = useState(false); //자료수정모달
  const [materialDeleteModal, setMaterialDeleteModal] = useState(false); //자료삭제모달
  const [materialPasswordTrue, setMaterialPasswordTrue] = useState(false); //삭제자료조건 스테이터

  //히스토리사용
  const history = useHistory();



  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    if (pwloading !== urlpw) {
      // window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login');
    }
    else {
    }
    // refreshPurchaseMaterialList()
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료;

  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        setPurSelectData(res.data);
      })
  }, [])

  //삭제조건 실행(materialDelete 모듈의 setPurchaseDeleteModal 변경시 싱행함)
  useEffect(() => {
    if (materialPasswordTrue === true) {
      onDelete()
      setMaterialPasswordTrue(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialPasswordTrue])

  const haneleSuppilerOnClick = ((e) => {
    //setMaterialNameChange('')
  })

  const haneleMaterialCodeOnChange = ((e) => {
    // e.preventDefault()
    setMaterialCode(e.target.value)
  })
  const haneleMaterialCodeOnClick = ((e) => {
    //setMaterialNameChange('')
  })

  const haneleMaterialGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialGubun(e.target.value)
  })
  const haneleMaterialGubunOnClick = ((e) => {
    //setMaterialNameChange('')
  })

  //자재사용유무
  const haneleMaterialYesNoOnChange = ((e) => {
    e.preventDefault()
    setMaterialYesNo(e.target.value)
  })


  //검색클릭 값변경
  const handleInputMaterialNameChange = (e) => {
    e.preventDefault();
    setMaterialNameChange(e.target.value);
  };

  //검색클릭
  const handleInputMaterialNameEnter = (e) => {
    e.preventDefault();
    if (materialNameChange !== '' && e.key === 'Enter') {
      refreshMaterialList(); // null이 아니면 실행됨
    }
    else {
      setMaterialList([]);
    }
  };

  //조회버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      r_자재업체코드: supplier.value ? supplier.value : null,   //업체코드
      r_자재규격: evValue.get("materialCode") ? evValue.get("materialCode") : null,
      r_자재구분: evValue.get("materialGubun") ? evValue.get("materialGubun") : null,
      r_자재사용유무: materialYesNo ? materialYesNo : null,
    }
    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/MaterialsList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, { params: { 
      materialUpcheCode:DataSerche.r_자재업체코드,
      materialCode: DataSerche.r_자재규격,
      materialGubun: DataSerche.r_자재구분,
      materialYesNo: DataSerche.r_자재사용유무 }})
      .then((res) => {
        setMaterialList(res.data);
      })
  };

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const meterialAPI = useCallback(() => {
    const url = '/api/MaterialsList/';
    const url01 = `/api/MaterialsList/${materialEditValue.Id}/`; //수정후 Id 쿼리 요청
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: { materialName: materialNameChange } }),
      fetchAllId: () => axios.get(url01, { params: { id: materialEditValue.Id } }), //조건조회요청
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          //alert('정상적으로 저장되었습니다.');
          Swal.fire({
            title: "<h5 style='color:blue'>정상적으로 저장되었습니다.</h5>",
            timer: 1500,
            confirmButtonText: "나가기",
          })
          // console.log(res.data)
        }).catch(error => {
          //alert("[규격[과 [업체명]이 동일할수가 없습니다[중복확인].")
          Swal.fire({
            title: "<h5 style='color:red'>[규격[과 [업체명]이 동일할수가 없습니다[중복확인].</h5>",
            confirmButtonText: "확인필요",
          })
          // console.log(error);
        }),
      update: (id, updatedRecord) =>
        axios.put(url + id, updatedRecord).then((res) => {
          //alert('정상적으로 수정되었습니다.');
          Swal.fire({
            title: "<h5 style='color:blue'>정상적으로 수정되었습니다.</h5>",
            timer: 1500,
            confirmButtonText: "나가기",
          })
        }).catch(error => {
          //alert("수정이 안되고 있습니다[입력항목및 중복을 확인하길 바랍니다.].")
          Swal.fire({
            title: "<h5 style='color:red'>수정이 안되고 있습니다[중복확인하시길 바랍니다]</h5>",
            confirmButtonText: "확인필요",
          })
          // console.log(error);
        }),
      delete: (id) => axios.delete(url + id, { params: { materialJajeCode: materialDeleteValue.r_자재코드, } }).then((res) => {
        //alert("정상적으로 삭제가 실행했습니다.")
        Swal.fire({
          title: "<h5 style='color:blue'>정상적으로 삭제가 실행했습니다.</h5>",
          timer: 1500,
          confirmButtonText: "나가기",
        })
      }).catch(error => {
        //alert("삭제가 실패했습니다.")
        Swal.fire({
          title: "<h5 style='color:red'>삭제가 실패했습니다.</h5>",
          confirmButtonText: "확인필요",
        })
        console.log(error);
      }),
      // download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [headers, materialDeleteValue.r_자재코드, materialEditValue.Id, materialNameChange]);

  const refreshMaterialList = useCallback(async () => {
    await meterialAPI()
      .fetchAll()
      .then((res) => {
        setMaterialList(res?.data);
      })
      .catch((err) => {
        console.log(err)
      });
  }, [meterialAPI]);

  //수정후 Id 쿼리
  const refreshMaterialListId = useCallback(async () => {
    await meterialAPI()
      .fetchAllId()
      .then((res) => {
        setMaterialList(res?.data);
      })
      .catch((err) => console.log(err));
  }, [meterialAPI]);

  const addOrEdit = useCallback(async (formData) => {
    if (formData.get('Id') === '0')
      await meterialAPI().create(formData)
        .then(res => {
          refreshMaterialList();
        })
        .catch(err => {
          console.log(err)
        })
    else
      await meterialAPI().update(formData.get('Id'), formData)
        .then(res => {
          refreshMaterialListId()
          // console.log(res.data)
        })
        .catch(err => {
          console.log(err)
        })
  }, [meterialAPI, refreshMaterialList, refreshMaterialListId])

  //삭제처리 
  const onDelete = useCallback(() => {
    meterialAPI()
      .delete(materialDeleteValue.Id)
      .then((res) => refreshMaterialList())
      .catch((err) => console.log(err));
  }, [materialDeleteValue.Id, meterialAPI, refreshMaterialList]);


  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      {
        name: "edit", header: "수정", align: "center", width: 60,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
        }
      },
      // { name: "Id", header: "Id", align: "left", width: 50 }, //숨김처리
      { name: "r_자재코드", header: "코드", align: "center", width: 80 },
      { name: "r_자재품번", header: "품번", align: "left", width: 100 },
      { name: "r_자재지출분류", header: "지출분류", align: "center", width: 65,
        renderer: {
          styles: {
            fontWeight: 'normal',
            color: '#0080ff',
            fontSize: '12px',
          }
        }
       },
      { name: "r_자재규격", header: "규격", align: "left", width: 230 },
      { name: "r_자재계정항목코드", header: "코드", align: "center", width: 70 },
      { name: "r_자재계정항목", header: "항목", align: "center", width: 75 },
      { name: "r_자재계정과목코드", header: "코드", align: "center", width: 70 },
      { name: "r_자재계정과목", header: "과목", align: "left", width: 100 },
      {
        name: "r_자재단위량", header: "단위량", align: "right", width: 70,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "r_자재단위", header: "단위", align: "center", width: 70 },
      {
        name: "r_자재단가", header: "단가", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "r_자재업체코드", header: "업체코드", align: "center", width: 80 },
      { name: "r_자재업체명", header: "업체명", align: "left", width: 220 },
      { name: "r_자재수불", header: "자재수불", align: "center", width: 70 },
      { name: "r_자재구분", header: "자재구분", align: "center", width: 70 },
      { name: "r_자재사용유무", header: "사용Yn", align: "center", width: 60 },
      {
        name: "r_등록일자", header: "등록일자", align: "center", width: 110,
        formatter: function (ev) {
          return `${moment(ev.value, "YYYY-MM-DD a hh:mm").format('YYYY-MM-DD HHmm')}`
        }
      },
      { name: "r_등록자", header: "등록자", align: "center", width: 80 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = materialList.map((row, index) => ({
    //id: row.id,
    No: index + 1,
    edit: '수정',
    // print: '인쇄',
    Id: row.id,
    r_자재코드: row.r_자재코드,
    r_자재품번: row.r_자재품번,
    r_자재지출분류: row.r_자재지출분류,
    r_자재규격: row.r_자재규격,
    r_자재계정항목코드: row.r_자재계정항목코드,
    r_자재계정항목: row.r_자재계정항목,
    r_자재계정과목코드: row.r_자재계정과목코드,
    r_자재계정과목: row.r_자재계정과목,
    r_자재단위량: Number(row.r_자재단위량),
    r_자재단위: row.r_자재단위,
    r_자재단가: Number(row.r_자재단가),
    r_자재업체코드: row.r_자재업체코드,
    r_자재업체명: row.r_자재업체명,
    r_자재수불: row.r_자재수불,
    r_자재구분: row.r_자재구분,
    r_자재사용유무: row.r_자재사용유무,
    r_등록일자: row.r_등록일자,
    r_등록자: row.r_등록자,
    delete: '삭제'
  }));

  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '자재',
        name: '자재',
        childNames: ['r_자재코드', 'r_자재품번','r_자재지출분류', 'r_자재규격']
      },
      {
        header: '계정항목',
        name: '계정항목;',
        childNames: ['r_자재계정항목코드', 'r_자재계정항목']
      },
      {
        header: '계정과목',
        name: '계정과목',
        childNames: ['r_자재계정과목코드', 'r_자재계정과목']
      },
      {
        header: '자재',
        name: '자재',
        childNames: ['r_자재단위량', 'r_자재단위', 'r_자재단가']
      },
      {
        header: '업체',
        name: '업체',
        childNames: ['r_자재업체코드', 'r_자재업체명']
      },
    ]
  }

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      // border: 'blue',
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        // background: 'pink',
        // border: '#C0C0C0',
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        // background: '#D8D8D8'
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = purSelectData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );

  //Grid 클릭처리
  const handleEditClick = ((ev) => {
    var rowKey = ev.rowKey
    // console.log(rowKey)
    const clickDeleteValue = gridRef.current.getInstance().getRow(ev.rowKey)
    // console.log(clickDeleteValue)

    if (ev.rowKey === rowKey && ev.columnName === 'edit') {
      // console.log(clickDeleteValue)
      setMaterialEditValue(clickDeleteValue);
      setMaterialEditModal(true);
    }
    else if (ev.rowKey === rowKey && ev.columnName === 'delete') {
      // console.log(clickDeleteValue)
      //console.log(`안녕하세요 ${rowKey}`)
      setMaterialDeleteValue(clickDeleteValue);
      setMaterialDeleteModal(true);
    }
    else {
      console.log('Grid 처리필드가 아님');
    }
  })

  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매자재등록</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12" >
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ''}
                size="small"
                style={{ width: 200, marginRight: 3 }}
                value={supplier ? supplier : setSupplier({ label: '', value: '' })}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재규격"
                name="materialCode"
                value={materialCode}
                autoComplete={materialCode}
                onChange={haneleMaterialCodeOnChange}
                onClick={haneleMaterialCodeOnClick}
              />
              <TextField
                style={{ width: 160, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재구분"
                name="materialGubun"
                value={materialGubun}
                autoComplete={materialGubun}
                onChange={haneleMaterialGubunOnChange}
                onClick={haneleMaterialGubunOnClick}
              />
              <FormControl
                variant="outlined"
                style={{ minWidth: 120, float: 'center', marginRight: '12px', }}
                size="small"
              >
                <InputLabel>자재사용YesNo</InputLabel>
                <Select
                  variant="outlined"
                  value={materialYesNo}
                  onChange={haneleMaterialYesNoOnChange}
                  label="자재사용YesNo"
                >
                  {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                  <MenuItem value={'Yes'}>Yes</MenuItem>
                  <MenuItem value={'No'}>No</MenuItem>
                </Select>
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 110,
                  marginRight: 3,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                variant="contained"
                startIcon={<InsertDriveFileIcon />}
                style={{
                  background: '#00838f',
                  color: 'white',
                  height: 36,
                  width: 100,
                  marginRight: 3,
                  float: "center",
                }}
                onClick={() => {
                  setMaterialCreateModal(true)
                }}
              >
                등록
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 110,
                  float: "center",
                }}
                onClick={() => {
                  window.location.href = "/home/index";
                }}
                // onClick={() => { history.goBack(); }}  //이게 더빠름
              >
                홈이동
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<FeaturedPlayListIcon />}
                style={{
                  background: '#b45f06',
                  color: 'white',
                  height: 36,
                  width: 145,
                  marginLeft: 20,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/Suppliers/PurchaseList');
                }}
              >
                업체등록이동
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<FeaturedPlayListIcon />}
                style={{
                  background: '#741b47',
                  color: 'white',
                  height: 36,
                  width: 145,
                  marginLeft: 5,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/MaterialsInput/MaterialInputList');
                }}
              >
                입출고등록이동
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="materialNameChange"
          value={materialNameChange}
          onChange={handleInputMaterialNameChange}
          onKeyUp={handleInputMaterialNameEnter}
          // onClick={() => {
          //   setMaterialNameChange('');
          //   setSupplier('')
          //   setMaterialCode('')
          //   setMaterialGubun('')
          // }}
        />
      </div>

      <Container maxWidth="xl">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={29}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50,
              resizable: true,
            }}
            ref={gridRef}
            onClick={handleEditClick}
          />
        </Box>
      </Container>
      {materialCreateModal === true ? <MaterialCreate materialCreateModal={materialCreateModal} setMaterialCreateModal={setMaterialCreateModal}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialEditModal === true ? <MaterialEdit materialEditModal={materialEditModal} setMaterialEditModal={setMaterialEditModal}
        materialEditValue={materialEditValue} setMaterialEditValue={setMaterialEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialDeleteModal === true ? <MaterialDelete materialDeleteModal={materialDeleteModal} setMaterialDeleteModal={setMaterialDeleteModal}
        materialDeleteValue={materialDeleteValue} setMaterialDeleteValue={setMaterialDeleteValue}
        materialPasswordTrue={materialPasswordTrue} setMaterialPasswordTrue={setMaterialPasswordTrue} urlpw={urlpw} /> : null}
    </>
  )
}

export default MaterialList